module.exports = __webpack_public_path__ + "img/add.61ca23ea.png";